import { trigger, transition, animate, style } from '@angular/animations';

export const OpenCloseSpinner = trigger('openCloseSpinner', [
    transition(':enter', [style({ opacity: 0 }), animate('0.25s cubic-bezier(0.5, 0, 0.1, 1)', style({ opacity: 1 }))]),
    transition(':leave', [animate('0.25s cubic-bezier(0.5, 0, 0.1, 1)', style({ opacity: 0 }))]),
]);
